<template lang="html">
  <div class=""></div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("destroyToken").then(response => {
      this.test = response;
      this.$router.push({ name: "login" });
    });
  }
};
</script>

<style lang="css" scoped></style>
